//set the values according database
export const Profiles = {
    Consultor: 1,
    ArquitetoDesigner: 2,
    AssistenciaTecnica: 3,
    Consumidor: 4,
}